(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 7314:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(4593);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5562:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/logo-with-text.45ff0eb5.svg","height":190,"width":402});

/***/ }),

/***/ 415:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/iphone-12-pro--graphite--awardwinning.59831f34.png","height":800,"width":395,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAICAMAAADp7a43AAAAKlBMVEXPz8/ExMTKzMy/vr6zsLGRnJ2AnaW5z9T////V1NSUlZLy8vLn5+j49PUV5u4EAAAACHRSTlPu+vz44+fe7svJzYYAAAAJcEhZcwAACxMAAAsTAQCanBgAAAApSURBVHicHcZBEgAQDATBiQSb4P/fVVy6ml41aNLE9mn4EpgE/viLzLgPqgC6PX7IUQAAAABJRU5ErkJggg==","blurWidth":4,"blurHeight":8});

/***/ }),

/***/ 4058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/iphone-12-pro--graphite--feed.14b960db.png","height":800,"width":395,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAICAMAAADp7a43AAAAKlBMVEW/wsPO0NDMzczHxcW1srORnZy5z9SAnaX////4+Pj8+vvX1taVlZL39/dnr/U3AAAACHRSTlP49u394+fu3k9Ix08AAAAJcEhZcwAACxMAAAsTAQCanBgAAAAqSURBVHicY2Dl4WFnYOTgYGNg5uJgZmDg5WBiYOAEE1xMIAlGBhZubhYAEAgAw5JV0NAAAAAASUVORK5CYII=","blurWidth":4,"blurHeight":8});

/***/ }),

/***/ 398:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/iphone-12-pro--graphite--lists.2d7d4fcb.png","height":800,"width":395,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAICAMAAADp7a43AAAAG1BMVEXT09PPz86vsbC0tLTFxcXDzMb+/v7X1NWcnJyZCzUMAAAABnRSTlPu+Ofe/ft9brMgAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIElEQVR4nGNg4uBgZmBlY2NgYGFjY2FgBLHQCCZ2dmYACtAAgrwnipkAAAAASUVORK5CYII=","blurWidth":4,"blurHeight":8});

/***/ }),

/***/ 2655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/iphone-12-pro--graphite--map.7222d6e8.png","height":800,"width":395,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAICAMAAADp7a43AAAAQlBMVEW9wbyWxNCUtbnBvbTR0M+3wsD///WOn6O2ubOwra6AssGhub7P5OHw69////+/6PHp//+bl5KRl5bi7ObW1tbT0NFGNQjbAAAADHRSTlPu7vzs8/v+4/vj+PevChWgAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAK0lEQVR4nAXBhQEAIAzAsOK24fz/Kglp7USI05BVLFkGVDnQVB2+d095t3wYSQFE093QiwAAAABJRU5ErkJggg==","blurWidth":4,"blurHeight":8});

/***/ }),

/***/ 5710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/iphone-12-pro--graphite--rating.9aa4886e.png","height":1467,"width":725,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAICAMAAADp7a43AAAARVBMVEWwrq7N0tO3trbFq5+cu8HAvbi0tLPMw8C1u729xsnV0M+enZ3////o8/Sy4u7b7On1+PDF3szW1db/2sfW0dL/v5ze6+92LC4+AAAAC3RSTlPi7tr48/nj9Pr07uSHDKkAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAsSURBVHicBcGFAQAgDMCwosMd/j+VBHIGKUUReo24ORJmXyG8GrGtWfxZ+gMX+QFMYlnfiQAAAABJRU5ErkJggg==","blurWidth":4,"blurHeight":8});

/***/ }),

/***/ 1836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/iphone-12-pro--graphite--review.7bd6ff99.png","height":800,"width":395,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAICAMAAADp7a43AAAAHlBMVEXQz87U1NSzsLCvucCwsLD////V6vDW1taYl5ff8PcDlJ8mAAAABXRSTlP57uT93t99GskAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAjSURBVHicY2Di4GBhYGBlZWRgZuNkZmBgY2OEcBEEEzs7EwAJ6gB3yodQSgAAAABJRU5ErkJggg==","blurWidth":4,"blurHeight":8});

/***/ }),

/***/ 4641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F2": function() { return /* binding */ ICON_MAP; },
/* harmony export */   "Q4": function() { return /* binding */ NAV_ROUTES; },
/* harmony export */   "RS": function() { return /* binding */ EXAMPLE_PROFILE_URL; },
/* harmony export */   "be": function() { return /* binding */ CONTACT_EMAIL; },
/* harmony export */   "iC": function() { return /* binding */ APP_NAME; }
/* harmony export */ });
/* unused harmony export BASE_URL */
const APP_NAME = "Gwak";
const CONTACT_EMAIL = "contact@getgwak.com";
const BASE_URL = "https://getgwak.com";
const ICON_MAP = {
    Favorites: "/page-assets/images/star-favorites.svg",
    All: "/page-assets/images/lightning.svg"
};
const EXAMPLE_PROFILE_URL = "/profiles/352c42a1-de04-41be-bb83-fc0ca81ecfad";
const NAV_ROUTES = [
    {
        label: "Who is this for?",
        path: "/who-is-this-for"
    },
    {
        label: "Create your own lists",
        path: "/curators"
    },
    {
        label: "Explore profiles",
        path: "/explore"
    },
    // { label: "Consumers", path: "/consumers" },
    {
        label: "About",
        path: "/about"
    }
];


/***/ }),

/***/ 6445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JP": function() { return /* binding */ Reddit; },
/* harmony export */   "O5": function() { return /* binding */ Discord; },
/* harmony export */   "fH": function() { return /* binding */ AppleAppStore; },
/* harmony export */   "kp": function() { return /* binding */ GooglePlay; },
/* harmony export */   "tL": function() { return /* binding */ Twitter; }
/* harmony export */ });
/* unused harmony exports Instagram, Facebook */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2322);

const GooglePlay = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        href: "https://play.google.com/store/apps/details?id=com.getgwak.gwak",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            src: "/page-assets/buttons/google-play.svg",
            alt: "Google Play Link"
        })
    });
};
const AppleAppStore = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        className: "mr-4",
        href: "https://apps.apple.com/us/app/gwak/id1626025395",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            src: "/page-assets/buttons/app-store.svg",
            alt: "Apple App Store link"
        })
    });
};
const Twitter = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        className: "mr-4 flex h-10 w-10 items-center justify-center rounded-full bg-gray-50",
        href: "https://twitter.com/gwakhq",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            src: "/page-assets/buttons/twitter.svg",
            alt: "Twitter link"
        })
    });
};
const Instagram = ()=>{
    return /*#__PURE__*/ _jsx("a", {
        className: "mr-4 flex h-10 w-10 items-center justify-center rounded-full bg-gray-50",
        href: "https://www.instagram.com/gwakhq",
        children: /*#__PURE__*/ _jsx("img", {
            src: "/page-assets/buttons/instagram.svg",
            alt: "Instagram link"
        })
    });
};
const Facebook = ()=>{
    return /*#__PURE__*/ _jsx("a", {
        className: "mr-4 flex h-10 w-10 items-center justify-center rounded-full bg-gray-50",
        href: "https://fb.me/gwakhq",
        children: /*#__PURE__*/ _jsx("img", {
            src: "/page-assets/buttons/facebook.svg",
            alt: "Facebook link"
        })
    });
};
const Reddit = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        className: "mr-4 flex h-10 w-10 items-center justify-center rounded-full bg-gray-50 p-3",
        href: "https://reddit.com/r/gwakapp",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            src: "/page-assets/buttons/reddit.svg",
            alt: "Reddit link"
        })
    });
};
const Discord = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        className: "mr-4 flex h-10 w-10 items-center justify-center rounded-full bg-gray-50 p-3",
        href: "https://discord.gg/PYEpy9VDGy",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            src: "/page-assets/buttons/discord.svg",
            alt: "Reddit link"
        })
    });
};


/***/ }),

/***/ 9148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Footer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2322);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Buttons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6445);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4641);
/* harmony import */ var _images_logo_with_text_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5562);
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8419);






function Footer() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "py-10",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "container mx-auto px-4",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "border-b border-gray-100",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "mb-6 flex flex-wrap items-start items-center justify-between",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mb-5 w-full lg:mb-0 lg:w-1/5",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    className: "inline-block text-xl font-semibold text-gray-900",
                                    href: "/",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        className: "h-10",
                                        src: _images_logo_with_text_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"].src */ .Z.src,
                                        alt: "",
                                        width: "auto"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "w-full lg:w-auto",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                    className: "flex flex-wrap items-center space-x-4 text-md lg:space-x-8",
                                    children: [
                                        _constants__WEBPACK_IMPORTED_MODULE_3__/* .NAV_ROUTES.map */ .Q4.map((param)=>/*#__PURE__*/ {
                                            let { label , path  } = param;
                                            return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                className: "mb-2 md:mb-0",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                    className: "text-md font-medium",
                                                    href: path,
                                                    children: label
                                                })
                                            }, label);
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            className: "mb-2 md:mb-0",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                className: "text-md font-medium",
                                                href: "mailto:".concat(_constants__WEBPACK_IMPORTED_MODULE_3__/* .CONTACT_EMAIL */ .be),
                                                children: "Contact Us"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-wrap items-center justify-between",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                className: "mt-8 text-md text-gray-500",
                                children: [
                                    (0,_util__WEBPACK_IMPORTED_MODULE_5__/* .getPrivacyPolicy */ .FH)(),
                                    " \xa9 ",
                                    _constants__WEBPACK_IMPORTED_MODULE_3__/* .APP_NAME */ .iC,
                                    " 2022"
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "order-first mt-8 flex sm:order-last",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Buttons__WEBPACK_IMPORTED_MODULE_2__/* .Twitter */ .tL, {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Buttons__WEBPACK_IMPORTED_MODULE_2__/* .Reddit */ .JP, {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Buttons__WEBPACK_IMPORTED_MODULE_2__/* .Discord */ .O5, {})
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 2429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ LargeLogoWithText; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2322);
/* harmony import */ var _images_logo_with_text_svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5562);


const LargeLogoWithText = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        className: "h-14",
        src: _images_logo_with_text_svg__WEBPACK_IMPORTED_MODULE_1__/* ["default"].src */ .Z.src,
        alt: "Gwak logo",
        width: "auto"
    });


/***/ }),

/***/ 2313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Nav; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2322);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Logo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2429);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4641);
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8419);





function Nav() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "py-8 px-4 xl:px-10",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            className: "text-xl font-medium",
                            href: "/",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Logo__WEBPACK_IMPORTED_MODULE_2__/* .LargeLogoWithText */ .s, {})
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "lg:hidden",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                className: "navbar-burger flex items-center rounded p-3 hover:bg-gray-50",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                    className: "block h-4 w-4",
                                    viewBox: "0 0 20 20",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                                            children: "Mobile menu"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                            d: "M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                            className: "hidden lg:ml-auto lg:mr-12 lg:flex lg:w-auto lg:items-center lg:space-x-12",
                            children: _constants__WEBPACK_IMPORTED_MODULE_3__/* .NAV_ROUTES.map */ .Q4.map((param)=>/*#__PURE__*/ {
                                let { label , path  } = param;
                                return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        className: "text-md font-medium",
                                        href: path,
                                        children: label
                                    })
                                }, path);
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "hidden lg:block",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: "inline-block rounded bg-red-400 py-3 px-8 text-md font-medium leading-normal text-white transition duration-200 hover:bg-red-300",
                                href: "mailto:".concat(_constants__WEBPACK_IMPORTED_MODULE_3__/* .CONTACT_EMAIL */ .be),
                                children: "Contact Us"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "navbar-menu fixed top-0 left-0 bottom-0 z-50 hidden w-5/6 max-w-sm",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "navbar-backdrop fixed inset-0 bg-gray-800 opacity-25"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("nav", {
                        className: "relative flex h-full w-full flex-col overflow-y-auto border-r bg-white py-6 px-6",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "mb-8 flex items-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        className: "mr-auto text-3xl font-medium leading-none",
                                        href: "/",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Logo__WEBPACK_IMPORTED_MODULE_2__/* .LargeLogoWithText */ .s, {})
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        className: "navbar-close",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                            className: "h-6 w-6 cursor-pointer text-gray-500 hover:text-gray-500",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            fill: "none",
                                            viewBox: "0 0 24 24",
                                            stroke: "currentColor",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round",
                                                strokeWidth: "2",
                                                d: "M6 18L18 6M6 6l12 12"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                    children: _constants__WEBPACK_IMPORTED_MODULE_3__/* .NAV_ROUTES.map */ .Q4.map((param)=>/*#__PURE__*/ {
                                        let { label , path  } = param;
                                        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            className: "mb-1",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                className: "block rounded p-4 text-md font-medium text-gray-900 hover:bg-gray-50",
                                                href: path,
                                                children: label
                                            })
                                        }, path);
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "mt-auto",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "pt-6",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            className: "block rounded bg-red-400 py-3 text-center text-md font-medium leading-normal text-white transition duration-200 hover:bg-red-300",
                                            href: "mailto:".concat(_constants__WEBPACK_IMPORTED_MODULE_3__/* .CONTACT_EMAIL */ .be),
                                            children: "Contact Us"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "mt-6 mb-4 text-center text-md text-gray-500",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                            children: [
                                                "\xa9 2022 ",
                                                (0,_util__WEBPACK_IMPORTED_MODULE_4__/* .getPrivacyPolicy */ .FH)(),
                                                "."
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 8419:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "kh": function() { return /* binding */ RatingToThumbsIcon; },
  "NZ": function() { return /* binding */ getPriceBadges; },
  "FH": function() { return /* binding */ getPrivacyPolicy; },
  "d4": function() { return /* binding */ getVibeBadges; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(9097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./images/ratings/double-thumbs-filled.png
/* harmony default export */ var double_thumbs_filled = ({"src":"/_next/static/media/double-thumbs-filled.fc16622c.png","height":468,"width":468,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAASFBMVEVMaXFmrPGQxPMjiOj///9TpfYQfOr///+12vv4/f9Kn/EskfKcy/WfzfX////E6/9ztfjU6fuRxfV2uvkAcOtstPUkmf9hsPtaKCbkAAAAFnRSTlMA4pT8BP79AnBB9PzlwBcNzoS14v/+81Wg4wAAAAlwSFlzAAALEwAACxMBAJqcGAAAAEBJREFUeJwVzIcVgCAMQMEfWqhiCbr/pj4GuAMUygTVEPIqALnXJI5ytbi8nTxfMh/fjMRkbbiD0aXeylYadvEDRRcB+MUpWzIAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./images/ratings/eye.png
/* harmony default export */ var eye = ({"src":"/_next/static/media/eye.a096d318.png","height":512,"width":512,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAG1BMVEVMaXENpOkOpOkOpusNp+0OpekOpecNo+gQu/8CQyLOAAAACHRSTlMAhq/5mjQ2OKHOeRkAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAsSURBVHicTYtBDgAgCMPWAcr/X2y8iLu0STNpVlCXhB1IdNrZjLwkbVjf9wAPogBwgUFndgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./images/ratings/thumb-down.png
/* harmony default export */ var thumb_down = ({"src":"/_next/static/media/thumb-down.bada9460.png","height":512,"width":512,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAJ1BMVEXwTU3yRETtOzvyRETyRETwQ0PwRETyRETxQ0PyRUX4SEjyRET/SUkbz7VsAAAADHRSTlMB/Q6ZrF987iO7KinLsiCIAAAACXBIWXMAAAsTAAALEwEAmpwYAAAANUlEQVR4nC3GyQ3AMAzEQGp1Obb6rzeIEX44gCQkcGsrD1abjcdDzY+48OBk9iQCthW3ld9eI04A9nixlp4AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./images/ratings/thumbs-up.png
/* harmony default export */ var thumbs_up = ({"src":"/_next/static/media/thumbs-up.91924f92.png","height":465,"width":512,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAJ1BMVEUAq0QVpEoWo0kSoEwVpEoWpUoWpUoUpEoVo0kVn0oWo0oXrk8XqEx0RxixAAAAC3RSTlMBc/0Rn8O0Sfcw2YcluKYAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAySURBVHicJcnJDcAgEMBAs0cgMf3XGyH8GskA2ZNTti8ws1xVA8djqBdr90V4Vhn7yx8fyAExNc27JAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":7});
;// CONCATENATED MODULE: ./src/common/util.tsx






const VIBE = {
    hiddenGem: "Hidden Gem",
    lunchSpot: "Lunch Spot",
    quickBite: "Quick Bite",
    weeknightDinner: "Weeknight Dinner",
    dateNight: "Date Night",
    bucketList: "Bucket List"
};
const PRICE = {
    cheap: "Cheap",
    reasonablyPriced: "Reasonably Priced",
    bitPricey: "Bit Pricey",
    expensive: "Expensive"
};
const getVibeBadges = (vibe)=>Object.entries(vibe).filter((param)=>{
        let [key, val] = param;
        return val;
    }).map((param)=>{
        let [key, val] = param;
        return key;
    }).map((key)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "bg-orange-200 text-orange-500 mb-1 mr-1 rounded py-1 px-2 align-middle font-medium",
            children: VIBE[key]
        }, key));
const getPriceBadges = (price)=>Object.entries(price).filter((param)=>{
        let [key, val] = param;
        return val;
    }).map((param)=>{
        let [key, val] = param;
        return key;
    }).map((key)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "mb-1 mr-1 rounded bg-green-200 py-1 px-2 align-middle font-medium text-green-500",
            children: PRICE[key]
        }, key));
const getPrivacyPolicy = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/privacy",
        children: "Privacy Policy"
    });
const RatingToThumbsIcon = {
    3: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        className: "h-6",
        src: double_thumbs_filled.src,
        alt: "Two thumbs up"
    }),
    2: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        className: "h-4",
        src: thumbs_up.src,
        alt: "Thumbs up"
    }),
    1: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        className: "h-4",
        src: thumb_down.src,
        alt: "Thumbs down"
    }),
    0: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        className: "h-5",
        src: eye.src,
        alt: "Watchlist"
    })
};


/***/ }),

/***/ 4593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Index; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(7729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./constants.ts
var constants = __webpack_require__(4641);
;// CONCATENATED MODULE: ./images/shield.svg
/* harmony default export */ var shield = ({"src":"/_next/static/media/shield.8524b79c.svg","height":21,"width":18});
;// CONCATENATED MODULE: ./images/letter.svg
/* harmony default export */ var letter = ({"src":"/_next/static/media/letter.db843fcc.svg","height":20,"width":22});
;// CONCATENATED MODULE: ./images/gem.svg
/* harmony default export */ var gem = ({"src":"/_next/static/media/gem.08f33fa9.svg","height":20,"width":20});
;// CONCATENATED MODULE: ./images/scanner.svg
/* harmony default export */ var scanner = ({"src":"/_next/static/media/scanner.2086db7d.svg","height":20,"width":24});
;// CONCATENATED MODULE: ./images/people.svg
/* harmony default export */ var people = ({"src":"/_next/static/media/people.fdbdf963.svg","height":18,"width":22});
;// CONCATENATED MODULE: ./images/exclamation.svg
/* harmony default export */ var exclamation = ({"src":"/_next/static/media/exclamation.4737c422.svg","height":20,"width":20});
;// CONCATENATED MODULE: ./images/choices.jpg
/* harmony default export */ var choices = ({"src":"/_next/static/media/choices.a1fa6bc4.jpg","height":427,"width":640,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAeEAABBAEFAAAAAAAAAAAAAAABAAIDEQQFBhQhUf/EABQBAQAAAAAAAAAAAAAAAAAAAAD/xAAWEQADAAAAAAAAAAAAAAAAAAAAATH/2gAMAwEAAhEDEQA/AJnf+oQmAYHCjtrw5st9tsWQPEREUDp//9k=","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./images/nice-restaurant.jpg
/* harmony default export */ var nice_restaurant = ({"src":"/_next/static/media/nice-restaurant.4c0e3570.jpg","height":480,"width":640,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAGAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAcEAABBAMBAAAAAAAAAAAAAAABAAIDIQQFUTH/xAAUAQEAAAAAAAAAAAAAAAAAAAAD/8QAFhEAAwAAAAAAAAAAAAAAAAAAAAER/9oADAMBAAIRAxEAPwCbqYMY6eGRsNtlFk2Rwnl+IiIqxYj/2Q==","blurWidth":8,"blurHeight":6});
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(6577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../node_modules/react-slick/lib/index.js
var lib = __webpack_require__(3467);
// EXTERNAL MODULE: ./src/common/Buttons.tsx
var Buttons = __webpack_require__(6445);
// EXTERNAL MODULE: ./src/common/Footer.tsx
var Footer = __webpack_require__(9148);
// EXTERNAL MODULE: ./src/common/nav.tsx
var nav = __webpack_require__(2313);
;// CONCATENATED MODULE: ./src/pages/index.tsx
















const screenshots = [
    __webpack_require__(4058),
    __webpack_require__(415),
    __webpack_require__(2655),
    __webpack_require__(1836),
    __webpack_require__(398),
    __webpack_require__(5710)
];
function Index() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Good Food Recommended by Friends | Gwak"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Gwak is a mobile app that curates restaurant recommendations from friends. Discover interesting places to eat and share your own lists of places to eat with others!"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(nav/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "absolute top-0 left-0 mt-32 hidden lg:block",
                        src: "/page-assets/icons/dots/blue-dot-left-bars.svg",
                        alt: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "absolute top-0 right-0 mt-32 hidden lg:block",
                        src: "/page-assets/icons/dots/yellow-dot-right.svg",
                        alt: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "container relative mx-auto px-4 text-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mx-auto mb-16 max-w-2xl",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: "font-heading mt-8 mb-10 text-5xl font-semibold",
                                        children: "A better way to discover new places to eat."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mx-auto mb-10 max-w-xl text-xl text-slate-500",
                                        children: "Use Gwak to get a curated list of restaurants from people you trust — no more aggregated reviews from strangers!"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mb-24 flex items-center justify-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons/* AppleAppStore */.fH, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons/* GooglePlay */.kp, {})
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    className: "mx-auto lg:max-w-3xl",
                                    src: "/page-assets/images/devices/3-devices-new.png",
                                    alt: ""
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "bg-gray-50 pt-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container relative mx-auto px-4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "-mx-4 flex flex-wrap items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full px-4 lg:w-1/2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "max-w-lg",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "mb-10 text-4xl font-semibold lg:mb-10 lg:pr-8",
                                            children: "Tired of scrolling through the same Yelp search results?"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "mb-6 text-xl text-gray-500",
                                            children: [
                                                "These days, it feels like there is both",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                    children: " too much information "
                                                }),
                                                " and",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                    children: " too little variation"
                                                }),
                                                " when it comes to discovering new restaurants."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "grid grid-cols-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "text-xl text-gray-500 underline",
                                                            children: "Too many:"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                            className: "mb-6 list-inside text-xl text-gray-500",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: "⭐ 4.3 Star ratings"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: "\uD83E\uDD16 Bots"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: "\uD83D\uDCB8 Ads"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: "\uD83E\uDD78 Fake reviews"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "text-xl text-gray-500 underline",
                                                            children: "Not enough:"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                            className: "mb-6 list-inside text-xl text-gray-500",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: "\uD83D\uDC8E Real hidden gems"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: "\uD83D\uDCE2 Sharing between friends"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: "\uD83E\uDD17 Human connection"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: "✨ Variability (always sorting on rating or number of reviews)"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative w-full px-4 lg:w-1/2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    className: "rounded-xl object-cover",
                                    src: choices.src,
                                    alt: ""
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "pt-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container mx-auto px-4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative -mx-4 flex flex-wrap-reverse items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full px-4 lg:w-2/5",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    className: "lg:h-128 h-96 w-full rounded-xl object-cover",
                                    src: nice_restaurant.src,
                                    alt: ""
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative w-full px-4 lg:w-3/5",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "relative lg:pl-10",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "font-heading mt-8 mb-10 text-4xl font-semibold lg:mb-10 lg:pr-8",
                                            children: "The Solution"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "mb-6 text-xl text-gray-500",
                                            children: [
                                                "Gwak is a mobile app that lets you follow specific people whose taste you trust. You only see reviews of restaurants for the people you follow. ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                    children: "Nothing else."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "mb-6 text-xl text-gray-500",
                                            children: "Going to Chicago for the weekend, but don't know where to eat? Follow some local Chicago friends and see what they suggest."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "mb-6 text-xl text-gray-500",
                                            children: "Don't know anyone in Chicago? Discover some local experts and give their curation a try!"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "mb-6 text-xl text-gray-500",
                                            children: "Whether you are a trailblazer finding the next hidden gem or the person who wants to spend less time sorting through the noise of Yelp and Google Maps, there's something for everyone."
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "py-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container mx-auto px-4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "-mx-4 flex flex-wrap",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mb-12 w-full px-4 lg:mb-0 lg:w-1/2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "font-heading mb-10 text-4xl font-semibold",
                                        children: "How it works"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "mb-12 max-w-lg text-xl text-gray-500",
                                        children: [
                                            "Gwak is an app that lets you follow specific tastemakers so you can personalize your own feed.",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: "You only see recommendations from people you follow."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-sm font-semibold text-red-400",
                                        children: "Download now!"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons/* AppleAppStore */.fH, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons/* GooglePlay */.kp, {})
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full px-4 lg:w-1/2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "bg-gray-75 rounded-xl px-10",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "border-b py-8",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex items-start items-center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "mr-6 flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-blue-400 text-white",
                                                        children: "1"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-gray-500",
                                                        children: "Follow friends and influencers whose taste you trust."
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "border-b py-8",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex items-start items-center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "mr-6 flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-orange-400 text-white",
                                                        children: "2"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-gray-500",
                                                        children: "Discover, eat, and rate restaurants yourself."
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "py-8",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex items-start items-center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "mr-6 flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-400 text-white",
                                                        children: "3"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-gray-500",
                                                        children: "Create your own lists and share them with others!"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container mx-auto px-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "font-heading mb-10 text-center text-4xl font-semibold",
                            children: "Features"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "-mx-3 flex flex-wrap",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mb-6 w-full px-3 md:w-1/2 lg:w-1/3",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "bg-gray-75 h-full rounded-lg p-6 md:p-8",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "mb-8 flex h-16 w-16 flex-shrink-0 items-center justify-center rounded-full bg-blue-400 md:mb-12",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: gem.src,
                                                    alt: "gem"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        className: "font-heading mb-4 text-2xl font-semibold",
                                                        children: "Find the gems"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-lg text-gray-500",
                                                        children: "Cut through the noise and hype. Lean on friends and get the inside scoop."
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mb-6 w-full px-3 md:w-1/2 lg:w-1/3",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "bg-gray-75 h-full rounded-lg p-6 md:p-8",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "mb-8 flex h-16 w-16 flex-shrink-0 items-center justify-center rounded-full bg-red-400 md:mb-12",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: exclamation.src,
                                                    alt: "exclamation"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        className: "font-heading mb-4 text-2xl font-semibold",
                                                        children: "Ignore the masses"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-lg text-gray-500",
                                                        children: "No more 4.3 vs 4.5 star analysis. Show me my friend's once-a-month regular spot."
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mb-6 w-full px-3 md:w-1/2 lg:w-1/3",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "bg-gray-75 h-full rounded-lg p-6 md:p-8",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "mb-8 flex h-16 w-16 flex-shrink-0 items-center justify-center rounded-full bg-teal-400 md:mb-12",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: shield.src,
                                                    alt: "shield with check"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        className: "font-heading mb-4 text-2xl font-semibold",
                                                        children: "Trustworthy sources"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-lg text-gray-500",
                                                        children: "No fake reviews, only people you trust."
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mb-6 w-full px-3 md:w-1/2 lg:mb-0 lg:w-1/3",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "bg-gray-75 h-full rounded-lg p-6 md:p-8",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "mb-8 flex h-16 w-16 flex-shrink-0 items-center justify-center rounded-full bg-orange-400 md:mb-12",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: letter.src,
                                                    alt: "letter"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        className: "font-heading mb-4 text-2xl font-semibold",
                                                        children: "Create your own curation"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-lg text-gray-500",
                                                        children: "Calling all foodies! Gwak makes it easy to start sharing the love. Highlight what stood out."
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mb-6 w-full px-3 md:w-1/2 lg:mb-0 lg:w-1/3",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "bg-gray-75 h-full rounded-lg p-6 md:p-8",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "mb-8 flex h-16 w-16 flex-shrink-0 items-center justify-center rounded-full bg-yellow-400 md:mb-12",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: scanner.src,
                                                    alt: "scanner"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        className: "font-heading mb-4 text-2xl font-semibold",
                                                        children: "Share once"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        className: "text-lg text-gray-500",
                                                        children: [
                                                            "Review once, share your lists with anyone.",
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: "underline",
                                                                href: constants/* EXAMPLE_PROFILE_URL */.RS,
                                                                children: "Check out an example profile"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mb-6 w-full px-3 md:w-1/2 lg:mb-0 lg:w-1/3",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "bg-gray-75 h-full rounded-lg p-6 md:p-8",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "mb-8 flex h-16 w-16 flex-shrink-0 items-center justify-center rounded-full bg-gray-900 md:mb-12",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: people.src,
                                                    alt: "people"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        className: "font-heading mb-4 text-2xl font-semibold",
                                                        children: "Bring back the human connection"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-lg text-gray-500",
                                                        children: 'Food tastes better when you can say "Hey, I loved that place you recommended"!'
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "py-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container mx-auto px-4 ",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "font-heading mb-10 text-4xl font-semibold",
                            children: "Video"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex justify-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: " w-full lg:w-1/2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                                    preload: "none",
                                    id: "vid1",
                                    controls: true,
                                    className: "video-js",
                                    poster: "/video-poster.png",
                                    "data-setup": "{}",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                        src: "/demo-video.mp4",
                                        type: "video/mp4"
                                    })
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container mx-auto px-4 ",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "font-heading mb-10 text-4xl font-semibold",
                            children: "Screenshots"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                            dots: true,
                            swipeToSlide: true,
                            arrows: false,
                            autoplay: true,
                            slidesToShow: 5,
                            slidesToScroll: 1,
                            autoplaySpeed: 2000,
                            responsive: [
                                {
                                    breakpoint: 640,
                                    settings: {
                                        slidesToShow: 2
                                    }
                                },
                                {
                                    breakpoint: 1024,
                                    settings: {
                                        slidesToShow: 3
                                    }
                                }
                            ],
                            children: screenshots.map((screenshot, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex justify-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "px-2",
                                        src: screenshot,
                                        alt: "screenshot"
                                    })
                                }, index))
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "py-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container mx-auto px-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "font-heading mb-10 text-center text-4xl font-semibold",
                            children: "FAQs"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "-mx-4 flex flex-wrap",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mb-12 w-full px-4 md:w-1/2 lg:mb-20 lg:w-1/3",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    className: "font-heading mb-1 text-2xl font-semibold",
                                                    children: "Does it cost anything?"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-base text-gray-500",
                                                    children: "Nope! Gwak is free to use."
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mb-12 w-full px-4 md:w-1/2 lg:mb-20 lg:w-1/3",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    className: "font-heading mb-1 text-2xl font-semibold",
                                                    children: "If I create a list of recommendations, do people need to sign up for Gwak to see my list?"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "text-base text-gray-500",
                                                    children: [
                                                        "No! Gwak auto-generates a lightweight profile web page for you that you can share with anyone. Even users who don't have the app yet. Check out this",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            className: "underline",
                                                            href: constants/* EXAMPLE_PROFILE_URL */.RS,
                                                            children: "example profile page"
                                                        }),
                                                        "."
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "bg-gray-50 py-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container mx-auto px-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "font-heading mb-10 text-center text-4xl font-semibold",
                            children: "Download Gwak now!"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-wrap justify-center space-x-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons/* GooglePlay */.kp, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons/* AppleAppStore */.fH, {})
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [949,577,467,774,888,179], function() { return __webpack_exec__(7314); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);